<!-- 人员变动申请 -->
<template>
  <div class="mod-sys__dimission">
    <!-- 查询条件：用户名 申请类型 审批结果 经销商 职位 品牌 申请时间 审批时间 -->
    <el-card shadow="never"
             class="aui-card--fill">
      <el-form label-position="top"
               :inline="true"
               :model="dataForm"
               @keyup.enter.native="getDataListMerge()">
        <el-row>
          <!-- 用户名 用户名/用户ID 查询两个条件 -->
          <el-col :span="5">
            <el-form-item :label="$t('user.name')">
              <el-input v-model="dataForm.userName"
                        type="text"
                        :placeholder="$t('change.userNamePlaceholder')"
                        clearable>
              </el-input>
            </el-form-item>
          </el-col>
          <!-- 申请类型 -->
          <el-col :span="5">
            <el-form-item :label="$t('change.applicationType')">
              <el-select v-model="dataForm.applicationType"
                         :placeholder="$t('change.applicationType')"
                         clearable>
                <el-option v-for="(item,index) in applicationTypeArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 审批结果 -->
          <el-col :span="5">
            <el-form-item :label="$t('change.approvalStatus')">
              <el-select v-model="dataForm.approvalStatus"
                         :placeholder="$t('change.approvalStatus')"
                         clearable>
                <el-option v-for="(item,index) in approvalStatusArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 所属公司简称 -->
          <el-col :span="5">
            <el-form-item :label="$t('user.orgAbbreviation')">
              <el-select v-model="dataForm.orgId"
                         remote
                         clearable
                         filterable
                         reserve-keyword
                         :placeholder="$t('user.input')"
                         :remote-method="orgSearch">
                <el-option v-for="item in orgList"
                           :key="item.orgId"
                           :label="item.name"
                           :value="item.orgId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-col :span="24">
              <el-button class="M-search"
                         style="margin-bottom: 7px"
                         @click="getDataListMerge()"
                         type="primary">{{ $t('query') }}</el-button>
            </el-col>
            <el-col :span="24">
              <el-button class="el-back M-search M-margin-l"
                         type="info"
                         @click="resetModify()">{{ $t('reset') }}</el-button>
            </el-col>
          </el-col>
        </el-row>
        <div v-show="isShow">
          <el-row>
            <!-- 主要职位 -->
            <el-col :span="5">
              <el-form-item :label="$t('user.position')">
                <el-select v-model="dataForm.jobCode"
                           remote
                           clearable
                           filterable
                           reserve-keyword
                           :placeholder="$t('user.position')"
                           :remote-method="positionSearch">
                  <el-option v-for="item in positionList"
                             :key="item.positionId"
                             :label="item.positionName"
                             :value="item.positionCode">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 品牌 -->
            <el-col :span="5">
              <el-form-item :label="$t('user.brandCodes')">
                <el-select v-model="dataForm.brandCode"
                           :placeholder="$t('user.brandCodes')"
                           clearable>
                  <el-option v-for="(item,index) in brandCodeArr"
                             :key="index"
                             :label="item.name"
                             :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 申请时间起止 -->
            <el-col :span="10">
              <el-form-item :label="$t('change.applicationDate')"
                            style="width: 100%!important;">
                <el-date-picker v-model="dataForm.applicationDateModify"
                                type="daterange"
                                value-format="yyyy-MM-dd"
                                :start-placeholder="$t('dimission.startData')"
                                :end-placeholder="$t('dimission.endData')"
                                :clearable="true"
                                :editable='false'
                                style="width: 90%">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <!-- 审批时间起止 -->
            <el-col :span="10">
              <el-form-item :label="$t('change.approvalDate')"
                            style="width: 100%!important;">
                <el-date-picker v-model="dataForm.approvalDateModify"
                                type="daterange"
                                value-format="yyyy-MM-dd"
                                :start-placeholder="$t('dimission.startData')"
                                :end-placeholder="$t('dimission.endData')"
                                :clearable="true"
                                :editable='false'
                                style="width: 90%">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <ToggleDiv @toggle="toggle"></ToggleDiv>
      <!-- 表头: 用户名 姓名 区域 省市 组织类型 所属组织 网点类型 品牌 申请类型 申请时间 审批时间 审批结果 -->
      <el-table :data="dataList"
                border
                v-loading="dataListLoading"
                style="width: 100%">
        <!-- 用户名 暂时不提供点击进入-->
        <el-table-column prop="userName"
                         align="center"
                         :label="$t('user.name')"
                         show-overflow-tooltip
                         width="150">
        </el-table-column>
        <!-- 用户ID -->
        <el-table-column prop="userCode"
                         align="center"
                         :label="$t('user.userID')"
                         show-overflow-tooltip
                         width="130">
        </el-table-column>
        <!-- 区域 -->
        <el-table-column prop="areaCode"
                         align="center"
                         :label="$t('organization.area')"
                         :formatter="areaCodeFormatter"
                         width="80"
                         show-overflow-tooltip>
        </el-table-column>
        <!-- 所在城市 -->
        <el-table-column prop="regionIds"
                         align="center"
                         :label="$t('organization.cityIds')"
                         :formatter="cityFormatter"
                         width="130"
                         show-overflow-tooltip>
        </el-table-column>
        <!-- 所属公司简称 -->
        <el-table-column prop="abbreviation"
                         align="center"
                         width="150"
                         :label="$t('user.orgAbbreviation')"
                         show-overflow-tooltip>
        </el-table-column>
        <!-- 所属公司全程 -->
        <el-table-column prop="name"
                         align="center"
                         width="150"
                         :label="$t('user.orgName')"
                         show-overflow-tooltip>
        </el-table-column>
        <!-- 主要职位 -->
        <el-table-column prop="positionName"
                         align="center"
                         width="150"
                         :label="$t('user.position')"
                         show-overflow-tooltip>
        </el-table-column>
        <!-- 网点类型 -->
        <el-table-column prop="networkType"
                         align="center"
                         :label="$t('user.outletType')"
                         show-overflow-tooltip
                         :formatter="networkTypeFormatter"
                         width="100">
        </el-table-column>
        <!-- 品牌 -->
        <el-table-column prop="brandCodes"
                         align="center"
                         :label="$t('user.brandCodes')"
                         width="100"
                         :formatter="brandCodeFormatter"
                         show-overflow-tooltip>
        </el-table-column>
        <!-- 申请类型 -->
        <el-table-column prop="applicationType"
                         align="center"
                         :label="$t('change.applicationType')"
                         :formatter="applicationTypeFormatter"
                         show-overflow-tooltip
                         width="90">
        </el-table-column>
        <!-- 申请时间 -->
        <el-table-column prop="applicationDate"
                         align="center"
                         :label="$t('change.applicationDate')"
                         :formatter="applicationDateFormatter"
                         show-overflow-tooltip
                         width="100">
        </el-table-column>
        <!-- 审批时间 -->
        <el-table-column prop="approvalDate"
                         align="center"
                         :label="$t('change.approvalDate')"
                         :formatter="approvalDateFormatter"
                         show-overflow-tooltip
                         width="100">
        </el-table-column>
        <!-- 审批结果 -->
        <el-table-column prop="approvalStatus"
                         align="center"
                         :label="$t('change.approvalStatus')"
                         :formatter="approvalStatusFormatter"
                         show-overflow-tooltip>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="pageSizeChangeHandle"
                     @current-change="pageCurrentChangeHandle"
                     :current-page="page"
                     :page-sizes="[10, 20, 50, 100]"
                     :page-size="limit"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="total">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import Vue from 'vue'
import mixinViewModule from '@/mixins/view-module'
import ToggleDiv from '@/components/toggle-div'
import { getRegionNameList } from '@/utils'
export default {
  mixins: [mixinViewModule],
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/commuserrecord/list',
        getDataListIsPage: true
      },
      dataForm: { // 查询条件
        userName: '',
        applicationType: '',
        approvalStatus: '',
        orgId: '',
        jobCode: '',
        brandCode: '',
        applicationDateModify: [],
        applicationDateStart: '',
        applicationDateEnd: '',
        approvalDateModify: [],
        approvalDateStart: '',
        approvalDateEnd: ''
      },
      applicationTypeArr: this.enums['applicationType'],
      approvalStatusArr: this.enums['approvalState'],
      brandCodeArr: this.enums['brandCode'],
      orgList: [], // 所属组织
      positionList: [], // 职位
      isShow: false // 展开更多
    }
  },
  components: {
    ToggleDiv
  },
  methods: {
    // 公司模糊搜索
    orgSearch(queryString) {
      this.$request.get('/sys/org/selectOrg',
        {
          name: queryString
        }
      ).then((res, total, code, data) => {
        this.orgList = res
      }).catch(() => { })
    },
    // 职位模糊搜索
    positionSearch(queryString) {
      this.$request.post('/sys/role/queryPositionByType',
        {
          positionName: queryString
        }
      ).then((res, total, code, data) => {
        this.positionList = res
      }).catch(() => { })
    },
    // 所在区域
    areaCodeFormatter(row) {
      return Vue.filter('coverEnum')(row.areaCode, 'area')
    },
    // 城市格式返回
    cityFormatter(row) {
      if (row.regionIds) {
        return getRegionNameList(row.regionIds)
      } else {
        return ''
      }
    },
    // 网点类型
    networkTypeFormatter(row) {
      return Vue.filter('coverEnum')(row.networkType, 'networkType')
    },
    // 品牌
    brandCodeFormatter(row) {
      return Vue.filter('coverEnumList')(row.brandCodes, 'brandCode', ',')
    },
    // 申请类型
    applicationTypeFormatter(row) {
      return Vue.filter('coverEnum')(row.applicationType, 'applicationType')
    },
    // 审批结果
    approvalStatusFormatter(row) {
      return Vue.filter('coverEnum')(row.approvalStatus, 'approvalState')
    },
    // 格式化时间没有时分秒
    applicationDateFormatter(row) {
      if (row.applicationDate !== '' && row.applicationDate) {
        return Vue.filter('formatDateNoTime')(row.applicationDate)
      } else {
        return ''
      }
    },
    // 格式化时间没有时分秒
    approvalDateFormatter(row) {
      if (row.approvalDate !== '' && row.approvalDate) {
        return Vue.filter('formatDateNoTime')(row.approvalDate)
      } else {
        return ''
      }
    },
    resetModify() {
      this.page = 1
      this.dataForm = {
        userName: '',
        applicationType: '',
        approvalStatus: '',
        orgId: '',
        jobCode: '',
        brandCode: '',
        applicationDateModify: [],
        applicationDateStart: '',
        applicationDateEnd: '',
        approvalDateModify: [],
        approvalDateStart: '',
        approvalDateEnd: ''
      }
      this.getDataList()
    },
    getDataListMerge() {
      if (this.dataForm.applicationDateModify !== '' && this.dataForm.applicationDateModify) {
        if (this.dataForm.applicationDateModify.length === 2) {
          this.dataForm.applicationDateStart = this.dataForm.applicationDateModify[0]
          this.dataForm.applicationDateEnd = this.dataForm.applicationDateModify[1]
        }
      } else {
        this.dataForm.applicationDateStart = ''
        this.dataForm.applicationDateEnd = ''
      }
      if (this.dataForm.approvalDateModify !== '' && this.dataForm.approvalDateModify) {
        if (this.dataForm.approvalDateModify.length === 2) {
          this.dataForm.approvalDateStart = this.dataForm.approvalDateModify[0]
          this.dataForm.approvalDateEnd = this.dataForm.approvalDateModify[1]
        }
      } else {
        this.dataForm.approvalDateStart = ''
        this.dataForm.approvalDateEnd = ''
      }
      this.getDataList()
    },
    // 展开更多
    toggle(data) {
      this.isShow = data
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
